import { MenuItem, styled } from '@mui/material';
import type { MenuItemProps } from '@mui/material/MenuItem';

import { goPalette, tsGoUnit } from '../../tsGoThemeVars';

export const StyledMenuItem = styled(MenuItem)<MenuItemProps>(() => ({
	minHeight: tsGoUnit.tsUnitTriple,
	position: 'relative',
	color: goPalette.tsGoColor.grayLightest,

	'&:hover': {
		background: 'rgba(0, 0, 0, 0.04)',

		a: {
			background: 'rgba(0, 0, 0, 0.04)',
		},
	},
	a: {
		minHeight: tsGoUnit.tsUnitTriple,
		padding: 0,
		minWidth: 0,
		position: 'relative',
		overflow: 'hidden',
		'a span:first-of-type': {
			paddingTop: tsGoUnit.tsUnit,
		},
		'a span': {
			padding: '10px 0',
		},
	},
	'a:hover': {
		cursor: 'pointer',
		color: goPalette.tsGoColor.grayLightest,
		textDecoration: 'none',
	},
	'&.active-option': {
		backgroundColor: 'rgba(25, 34, 38, 1)',
		overflow: 'hidden',

		'.expanded, .collapsed': {
			color: goPalette.tsGoColor.grayLightest,
		},

		':hover': {
			backgroundColor: 'rgba(25, 34, 38, 1)',
		},
		'&:before': {
			backgroundColor: goPalette.tsGoColor.pink,
			position: 'absolute',
			width: '3px',
			content: '""',
			top: 0,
			bottom: 0,
			boxShadow: `0 0 15px 1px ${goPalette.tsGoColor.pink}`,
		},
	},
}));
